var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPuzzleLine = function SvgPuzzleLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.875 5.625a2.5 2.5 0 0 1 5 0H15c.345 0 .625.28.625.625v2.607a.625.625 0 0 1-.833.589q-.196-.07-.417-.071a1.25 1.25 0 1 0 .417 2.43.625.625 0 0 1 .833.588V15c0 .345-.28.625-.625.625H5A.625.625 0 0 1 4.375 15V6.25c0-.345.28-.625.625-.625zm2.5-1.25a1.25 1.25 0 0 0-1.179 1.667.625.625 0 0 1-.59.833H5.626v7.5h8.75v-1.25a2.5 2.5 0 0 1 0-5v-1.25h-3.232a.625.625 0 0 1-.589-.833q.07-.196.071-.417c0-.69-.56-1.25-1.25-1.25"
  })));
};
export default SvgPuzzleLine;